import { useI18n } from "@/context/I18nContext";
import { Users, MonitorSmartphone, Bike } from "lucide-react";
import { PosCard, RankTable } from "./PosTable";
import { OPS } from "@/constants/testIds";

const PI = OPS.posInsights;

export default function PosStaffPanel({ data }) {
    const { t, lang } = useI18n();
    const nameOf = (r) => (lang === "ar" ? r.name_ar || r.name_en : r.name_en || r.name_ar);

    return (
        <div className="grid grid-cols-1 gap-4">
            <PosCard icon={Users} title={t("pi_cashiers")}>
                <RankTable
                    testId={PI.cashiers}
                    rows={data?.cashiers || []}
                    columns={[
                        { key: "name", label: t("pi_cashiers"), strong: true },
                        { key: "orders", label: t("pi_col_orders"), type: "int" },
                        { key: "total", label: t("pi_col_total"), type: "num" },
                        { key: "avg_ticket", label: t("pi_avg_ticket_short"), type: "num" },
                    ]}
                    shareKey="total"
                    rowTestId={(r, i) => `pos-insights-cashier-${i}`}
                />
            </PosCard>
            <div className="grid grid-cols-1 gap-4 lg:grid-cols-2">
                <PosCard icon={MonitorSmartphone} title={t("pi_terminals")}>
                    <RankTable
                        testId={PI.terminals}
                        rows={data?.terminals || []}
                        columns={[
                            { key: "name", label: t("pi_terminals"), strong: true },
                            { key: "orders", label: t("pi_col_orders"), type: "int" },
                            { key: "total", label: t("pi_col_total"), type: "num" },
                        ]}
                        shareKey="total"
                        rowTestId={(r) => `pos-insights-terminal-${r.posid}`}
                    />
                </PosCard>
                <PosCard icon={Bike} title={t("pi_delivery_men")}>
                    <RankTable
                        testId={PI.deliveryMen}
                        rows={(data?.delivery_men || []).map((r) => ({ ...r, name: nameOf(r) }))}
                        columns={[
                            { key: "name", label: t("pi_delivery_men"), strong: true },
                            { key: "orders", label: t("pi_col_orders"), type: "int" },
                            { key: "total", label: t("pi_col_total"), type: "num" },
                        ]}
                        shareKey="total"
                        rowTestId={(r, i) => `pos-insights-delivery-man-${r.id ?? i}`}
                    />
                </PosCard>
            </div>
        </div>
    );
}
